export default {
  username: "0～9およびA～Zの英数字3文字の組み合わせ."
  // password: "0～9およびA～Zの英数字4～12文字の組み合わせ"
};